import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// ANCHOR NGPRIME
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ImageModule } from 'primeng/image';
import { GalleriaModule } from 'primeng/galleria';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ViewImageModalComponent } from './components/view-image-modal/view-image-modal.component';


@NgModule({
  declarations: [

  
    ViewImageModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CarouselModule,
    DropdownModule,
    InputNumberModule,
    InputSwitchModule,
    TableModule,
    ToggleSwitchModule,
    NgbNavModule,
    NgbTooltipModule,
    ImageModule,
    GalleriaModule,
    ProgressSpinnerModule,
    NgSelectModule,
    NgbModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CarouselModule,
    DropdownModule,
    InputNumberModule,
    InputSwitchModule,
    TableModule,
    ToggleSwitchModule,
    NgbNavModule,
    NgbTooltipModule,
    ImageModule,
    GalleriaModule,
    ProgressSpinnerModule,
    NgSelectModule,
    NgbModule
  ]
})
export class SharedModule { }
